import(/* webpackMode: "eager" */ "/app/node_modules/react-fast-marquee/dist/index.js");
;
import(/* webpackMode: "eager", webpackExports: ["ExploreMoreCustomersSection"] */ "/app/src/sections/customers/ExploreOurCustomersSection/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["FeaturedStoriesSection"] */ "/app/src/sections/customers/FeaturedStoriesSection/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["HeroSection"] */ "/app/src/sections/customers/HeroSection/index.tsx");
